module.exports = {

    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            "res/sounds/bet-up",
            "res/sounds/bet-down",
            "res/sounds/credits",
            "res/sounds/winflow",
            "res/sounds/spin/spin_0",
            "res/sounds/bar_stop/drum_stop",
            "res/sounds/scatter/scatter_0",
            "res/sounds/scatter/scatter_1",
            "res/sounds/scatter/scatter_2",
            "res/sounds/scatter/scatter_3",
            "res/sounds/scatter/scatter_4",
            "res/sounds/doublegame/blink",
            "res/sounds/doublegame/lose",
            "res/sounds/doublegame/win1",
            "res/sounds/doublegame/win2",
            "res/sounds/doublegame/win3",
            "res/sounds/doublegame/win4",
            "res/sounds/doublegame/rotate",
            "res/sounds/freegame/end",
            "res/sounds/freegame/start",
            "res/sounds/freegame/scatters",
            "res/sounds/freegame/music",
            "res/sounds/help/click",
            "res/sounds/wins/AK_3",
            "res/sounds/wins/budilnik",
            "res/sounds/wins/cent_3",
            "res/sounds/wins/long_pipim",
            "res/sounds/wins/man_2",
            "res/sounds/wins/man_3",
            "res/sounds/wins/win",
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/mainbackground.jpg",
            "res/lines_frames_billets.json",
            "res/slot_symbols.json",
            "res/symbol_animations.json",
            "res/help/page_0.jpg",
            "res/help/page_1.jpg",
            "res/help/page_2.jpg",
            "res/doublegame_background.jpg",
            "res/double_game.json",
            "res/freegames_finish_table.png",
            "res/freegames_start_table.png",
            "res/freegames_add_table.png",
            "res/freegames_money_table.png",

            "res/fonts/arial_bold_24.xml",
            "res/fonts/arial_bold_14.xml",
            "res/fonts/arial_bold_18.xml",
            "res/fonts/arial_bold_yelow_14.xml",
            "res/fonts/freegamewin-font.xml",
        ]
};




//////////////////
// WEBPACK FOOTER
// ./res/resources.js
// module id = 27
// module chunks = 0